import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Avatar, Dropdown, Menu } from 'antd';
import { useModules } from '@store/user';
import { classNames } from '@src/utils';
import { useLogout, useUser } from '@src/services/login';
import './user-menu.scss';
var prefixCls = 'user-menu';
var UserMenu = function (props) {
    var history = useHistory();
    /** 获取用户信息 */
    var userInfo = useUser();
    var modules = useModules(userInfo === null || userInfo === void 0 ? void 0 : userInfo.xuexinID, 0);
    var className = useMemo(function () {
        return classNames(prefixCls, props.className);
    }, [props.className]);
    /** 退出 */
    var mutateAsync = useLogout().mutateAsync;
    var list = useMemo(function () {
        return modules
            .reduce(function (list, item) {
            if (item.active === 0) {
                return list;
            }
            var menuItem = {
                value: item.code,
                text: '',
                link: void 0,
            };
            return list.concat(menuItem);
        }, [{ value: 'profile', text: '基本资料' }])
            .concat({ value: 'logout', text: '退出' });
    }, [modules]);
    var handleMenuOnClick = function (_a) {
        var key = _a.key;
        switch (key) {
            case 'profile' /** 基本资料 */:
                history.push('/profile');
                break;
            case 'logout':
                mutateAsync({}).then(function () {
                    sessionStorage.clear();
                    window.location.href = '/login';
                });
                break;
            default:
                break;
        }
    };
    var Menus = (React.createElement(Menu, { onClick: handleMenuOnClick }, list.map(function (item) {
        return (React.createElement(Menu.Item, { key: item.value }, item.link !== void 0 ? (React.createElement("a", { href: item.link, target: "_blank", rel: "noopener noreferrer" }, item.text)) : (item.text)));
    })));
    return (React.createElement(React.Fragment, null,
        React.createElement(Dropdown, { className: className, overlay: Menus, placement: "bottomRight", overlayClassName: prefixCls + "_dropdown" },
            React.createElement("div", null,
                React.createElement(Avatar, { size: 28, src: userInfo === null || userInfo === void 0 ? void 0 : userInfo.avatar }),
                React.createElement("span", { className: prefixCls + "_name" }, userInfo === null || userInfo === void 0 ? void 0 : userInfo.realName)))));
};
export default React.memo(UserMenu);
